.progressBar {
  gap: 12px;
  padding: 0 9px;
}

.step {
  background-color: var(--colors-primary-main);
  border-radius: 100px;
}

.pendingStep {
  background: var(--colors-grays-ultralight);
}

.currentStep {
  width: 8px;
  height: 8px;
  border-radius: 24px;
  background: var(--colors-grays-white);
}

.line {
  height: 2px;
  border-radius: 100px;
  background: var(--colors-grays-ultralight);
}

.lineActive {
  background: var(--colors-primary-main);
}

.stepLabel {
  text-align: center;
  white-space: nowrap;
}

.mobileLabel {
  display: none;
}

@media (--reefer-media-tablet-max) {
  .progressBar {
    gap: 4px;
    padding: 0;
  }

  .stepLabel {
    display: none;
  }

  .mobileLabel {
    display: block;
    margin-top: 12px;
    text-align: center;
  }
}
